// Vendors
import { gsap, TweenMax } from "gsap";
import { Block, ReleaseBlock } from "shared/model";
import { DefaultConfig, ScoreConfig, MechanicsConfig } from "shared/config";
import { LoaderService, FillBarService } from "shared/services";
import { LevelObject } from "shared/levels";

export class GenerateLevelService {
    private currentMechanic: string;
    private container;
    private drag: boolean = false;
    private matrix;
    private clusters;
    private tiles;
    private score: number = 0;
    private substrate;

    public startLevel(data) {
        const matrix = data.matrix;
        this.container = data.container;
        this.currentMechanic = JSON.parse(localStorage.getItem('current_mechanic'));
        // this.container.on("pointerdown", this.onMouseDown);
        // this.container.on("pointerup", this.onMouseUp);
        // this.container.on("pointermove", this.onMouseMove);

        const tilesContainer = new PIXI.Container();
        const substrateContainer = new PIXI.Container();
        const helperBloclsContainer = new PIXI.Container();
        this.matrix = matrix;
        for (let i = 0; i < matrix.length; i++) {
            LevelObject.tiles[i] = [];
            for (let j = 0; j < matrix[i].length; j++) {
                LevelObject.tiles[i][j] = [];
                for (let d = 0; d < matrix[i][j].length; d++) {
                    const sprite = this.createTile(i, j, d);
                    LevelObject.tiles[i][j].push(sprite);
                    tilesContainer.addChild(sprite);

                    if (sprite.alpha !== 0) {
                        const substrate = this.createSubstate(j, d);
                        substrateContainer.addChild(substrate);
                    }
                }
            }
        }
        this.tiles = tilesContainer;
        this.substrate = substrateContainer;
        return {
            tiles: tilesContainer,
            substrate: substrateContainer,
        };
    }

    private createTile(i, j, d): Block {
        let sprite: Block;

        const colors = DefaultConfig.colors;
        const color = colors[Math.floor(Math.random() * colors.length)];
        switch (color) {
            case 'red': {
                sprite = new Block(LoaderService.getResource('tile1').texture);
                sprite.color = 'red';
                sprite.type = 1;
                break;
            }
            case 'green': {
                sprite = new Block(LoaderService.getResource('tile2').texture);
                sprite.color = 'green';
                sprite.type = 2;
                break;
            }
            case 'blue': {
                sprite = new Block(LoaderService.getResource('tile3').texture);
                sprite.color = 'blue';
                sprite.type = 3;
                break;
            }
            case 'brown': {
                sprite = new Block(LoaderService.getResource('tile4').texture);
                sprite.color = 'brown';
                sprite.type = 4;
                break;
            }
            case 'yellow': {
                sprite = new Block(LoaderService.getResource('tile5').texture);
                sprite.color = 'yellow';
                sprite.type = 5;
                break;
            }
        }
        const coord = this.getCoordinateTile(j, d);
        sprite.width = LevelObject.tileWidth - LevelObject.tilesMargin;
        sprite.height = LevelObject.tileHeight - LevelObject.tilesMargin;
        sprite.x = coord.tileX;
        sprite.y = coord.tileY;
        sprite.mapNum = i;
        sprite.row = d;
        sprite.col = j;
        sprite.isDelete = false;
        // sprite.stateMachine = new BlockStateMashine(sprite);
        sprite.shift = 0;

        // if (this.matrix[i][d][j] === 0) {
        //     sprite.alpha = 0;
        // }

        return sprite;
    }

    private createSubstate(j, d): PIXI.Sprite {
        const sprite = new PIXI.Sprite(LoaderService.getResource('cell').texture);
        const coord = this.getCoordinateTile(j, d);
        sprite.width = LevelObject.tileWidth + LevelObject.tilesMargin - LevelObject.tilesMargin - 8;
        sprite.height = LevelObject.tileHeight + LevelObject.tilesMargin - LevelObject.tilesMargin - 8;
        sprite.x = coord.tileX - 4;
        sprite.y = coord.tileY - 4;

        if (d % 2) {
            sprite.alpha = 0.55;
        } else {
            sprite.alpha = 0.7;
        }
        return sprite;
    }


    public async getAllChains(isStart: boolean, isNeedToRemove: boolean, isAuto: boolean) {
        this.container.interactive = false;
        const grid = LevelObject.tiles;
        let result = [];
        let row: number;
        let col: number;
        for (let i = 0; i < grid.length; i++) {
            for (row = 0; row < grid[i].length; row++) {
                result = result.concat(this.getHorizontalChains(grid[i], row));
            }

            for (col = 0; col < grid[i].length; col++) {
                result = result.concat(this.getVerticalChains(grid[i], col));
            }
        }

        if (result.length > 0 && isNeedToRemove) {
            this.deleteChains(result, isStart);


            return true;
        } else if (!isNeedToRemove) {
            this.clusters = result;
            return true;
        }
        this.container.interactive = true;
        return false;
    }

    private deleteChains(chains, isStart): void {
        const tiles = LevelObject.tiles;
        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                let shift = 0;
                for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                    const tile = LevelObject.tiles[i][j][d];
                    if (tile.type === -1) {
                        shift += 1;
                        // LevelObject.tiles[i][j].splice(d, 1);
                        // this.tiles.removeChild(tile);
                    } else {
                        tiles[i][j][d].shift = shift;
                        if (tiles[i][j][d].row >= 7) {
                            tiles[i][j][d].row = 6;
                        }
                        tiles[i][j][d].row = tiles[i][j][d].row + shift;   
                    }
                }
            }
        }

        this.moveBlocks(isStart);
    }

    private moveBlocks(isStart: boolean): void {
        let needToAnim = [];
        const tiles = LevelObject.tiles;

        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                let deletedTiles = 0;
                for (let d = tiles[i][j].length; d >= 0; d--) {
                    const tile = tiles[i][j][d];

                    if (tile && tile.type === -1) {
                        LevelObject.tiles[i][j].splice(d, 1);
                        this.tiles.removeChild(tile);
                        deletedTiles += 1;
                        continue;
                    }

                    if (tile && tile.shift > 0) {
                        needToAnim.push(tile);
                    }
                }

                if (deletedTiles > 0) {
                    const newTiles = this.createNewTiles(i, j, deletedTiles);
                    needToAnim = needToAnim.concat(newTiles);
                }
            }
        }


        if (isStart) {
            for (let i = 0; i < needToAnim.length; i++) {
                needToAnim[i].y = needToAnim[i].y + (needToAnim[i].height + LevelObject.tilesMargin) * needToAnim[i].shift;
                needToAnim[i].shift = 0;
                if (this.matrix[needToAnim[i].mapNum][needToAnim[i].row][needToAnim[i].col] !== 0) {
                    needToAnim[i].alpha = 1;
                } else {
                    needToAnim[i].alpha = 0;
                }
            }
            this.container.interactive = true;
            this.getAllChains(true, true, true);
        } 
        else {
            this.animLower(needToAnim);
        }
    }

    private async animLower(tiles) {
        await new Promise((res, rej) => {
            for (let i = 0; i < tiles.length; i++) {
                tiles[i].alpha = 0;
                gsap.to(tiles[i], {
                    y: `+=${Math.floor((tiles[i].height + LevelObject.tilesMargin) * tiles[i].shift)}`, duration: 0.7, ease: 'none', 
                    onComplete: () => {
                        tiles[i].shift = 0;
                        res();
                    },
                    onUpdate: () => {
                        if (tiles[i].y >= -tiles[i].height) {
                            tiles[i].alpha = 1;
                        }
                    },
                })
            }
        })

        setTimeout(() => {
            this.container.interactive = true;
            this.getAllChains(false, true, true)
        }, 400)
        // this.findMoves(false)
    }

    private getHorizontalChains(grid, row: number): any[] {
        let result: any[] = [];
        let horizontal: any[];
        let piece;
        let pieceBefore;
        let col: number;
        pieceBefore = grid[0][row];
        horizontal = [];
        horizontal.push(pieceBefore);
        for (col = 1; col < grid.length; col++) {
            piece = grid[col][row];
            if (piece.type === pieceBefore.type
                && piece.alpha !== 0 && pieceBefore.alpha !== 0) {
                horizontal.push(piece);
            } else {
                if (horizontal.length >= 3) {
                    result = result.concat(horizontal);
                }
                horizontal = [];
                horizontal.push(piece);
            }

            pieceBefore = piece;
        }
        if (horizontal.length >= 3) {
            result = result.concat(horizontal);
        }
        if (result.length >= 3) {
            for (let i = 0; i < result.length; i++) {
                const tile = result[i];
                result[i].type = -1;
            }
        }

        return result;
    }

    private getVerticalChains(grid, col: number): any[] {
        let result: any[] = [];
        let vertical: any[];
        let piece;
        let pieceBefore;
        let row: number;

        pieceBefore = grid[col][0];

        vertical = [];
        vertical.push(pieceBefore);

        for (row = 1; row < grid.length; row++) {
            piece = grid[col][row];

            if (piece.type === pieceBefore.type
                && piece.alpha !== 0 && pieceBefore.alpha !== 0) {
                vertical.push(piece);
            } else {
                if (vertical.length >= 3) {
                    result = result.concat(vertical);
                }
                vertical = [];
                vertical.push(piece);
            }

            pieceBefore = piece;
        }
        if (vertical.length >= 3) {
            result = result.concat(vertical);
        }

        if (result.length >= 3) {
            for (let i = 0; i < result.length; i++) {
                const tile = result[i];
                result[i].type = -1;
            }
        }

        return result;
    }

    private createNewTiles(atrI, j, needToAdd): any[] {
        const array = [];
        let firstTile = LevelObject.tiles[atrI][j][0];
        let firstNotCreated = LevelObject.tiles[atrI][j][0];
        for (let i = 0; i < needToAdd; i++) {
            firstTile = LevelObject.tiles[atrI][j][0];
            let sprite;

            sprite = this.createTile(atrI, j, i);
            sprite.isNew = true;
            sprite.y = firstTile.y - (sprite.height + LevelObject.tilesMargin);
            sprite.shift = firstTile.shift;
            sprite.row = firstTile.row - 1;

            if (firstNotCreated.shift === 0 && needToAdd === 1) {
                sprite.y = 0 - (sprite.height + LevelObject.tilesMargin);
                sprite.shift = 1;
            }

            if (firstNotCreated.shift === 0 && needToAdd > 1) {
                sprite.shift = needToAdd;
                sprite.y = 0 - ((sprite.height + LevelObject.tilesMargin) * (i + 1))
            }
            // sprite.shift += emptyNum;
            array.unshift(sprite);
            LevelObject.tiles[atrI][j].unshift(sprite);
            this.tiles.addChild(sprite);
        }

        return array;
    }

    private onMouseDown(e) {
        this.drag = false;
        // Get the mouse position
        const pos = this.getMousePos(this, e);

        // Start dragging
        if (!this.drag) {
            // Get the tile under the mouse
            let mt = this.getMouseTile(pos);
            // const tile = LevelObject.tiles[mt.map][mt.x][mt.y];
            // if (tile && mt.valid && tile.alpha !== 0) {
            //     // Valid tile
            //     LevelObject.selectedTile.column = mt.x;
            //     LevelObject.selectedTile.row = mt.y;
            //     LevelObject.selectedTile.selected = true;
            // } else {
            //     // Invalid tile
            //     LevelObject.selectedTile.selected = false;
            // }

            // Start dragging
            this.drag = true;
        }

        // for (let i = 0; i < LevelObject.columns; i++) {
        //     for (let j = 0; j < LevelObject.rows; j++) {

        //         // Draw the selected tile
        //         if (LevelObject.selectedTile.selected) {
        //             if (LevelObject.selectedTile.column == i && LevelObject.selectedTile.row == j) {
        //                 // Draw a red tile
        //                 const selectedTile = LevelObject.tiles[LevelObject.selectedTile.column][LevelObject.selectedTile.row];
        //             }
        //         }
        //     }
        // }

        // this.renderTiles();
    }

    private createHelperTile(tile) {
        const block = new ReleaseBlock();
        const graphics = new PIXI.Graphics();
        block.zIndex = 100;
        graphics.beginFill(0x000000);
        graphics.drawRect(tile.x - LevelObject.tilesMargin / 2, tile.y  - LevelObject.tilesMargin / 2, 
            tile.width + LevelObject.tilesMargin, tile.height + LevelObject.tilesMargin);
        block.addChild(graphics);
        block.alpha = 0.6;
        block.isRelease = false
        return block;
    }

    private getMouseTile(pos) {
        // Calculate the index of the tile
        const tx = Math.floor((pos.x) / (LevelObject.tileWidth));
        const ty = Math.floor((pos.y) / (LevelObject.tileHeight));
        // var tx = Math.floor((pos.x - LevelObject.x) / LevelObject.tileWidth);
        // var ty = Math.floor((pos.y - LevelObject.y) / LevelObject.tileHeight);

        // Check if the tile is valid
        const tiles = LevelObject.tiles;
        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                if (tx >= 0 && tx < tiles[i][j].length && ty >= 0 && ty < tiles[i].length) {
                    // Tile is valid
                    return {
                        valid: true,
                        map: i,
                        x: tx,
                        y: ty
                    };
                }
            }
        }

        // No valid tile
        return {
            valid: false,
            map: 0,
            x: 0,
            y: 0
        };
    }

    public getMousePos(canvas, e) {
        const rect = canvas.getBounds();
        return {
            x: Math.round((e.data.global.x - rect.left) / (rect.right - rect.left) * canvas.width),
            y: Math.round((e.data.global.y - rect.top) / (rect.bottom - rect.top) * canvas.height)
        };
    }

    public getCoordinateTile(column, row) {
        var tileX = column * (LevelObject.tileWidth);
        var tileY = row * (LevelObject.tileHeight);
        // var tileX = LevelObject.x + column  * LevelObject.tileWidth;
        // var tileY = LevelObject.y + row * LevelObject.tileHeight;
        return { tileX: tileX, tileY: tileY };
    }
}